import clsxm from "@/lib/clsxm";
import {FC, PropsWithChildren, memo, useEffect, useRef} from "react";
import {useClickAway, useLocation} from "react-use";

const SideDrawer: FC<{isOpen: boolean; toggleOpen(isOpen?: boolean): void} & PropsWithChildren> = ({
  isOpen,
  toggleOpen,
  children,
}) => {
  const location = useLocation();

  const ref = useRef<HTMLDivElement>(null);
  useClickAway(ref, () => toggleOpen(false));

  useEffect(() => {
    toggleOpen(false);
  }, [location, toggleOpen]);

  return (
    <div ref={ref}>
      <button className="flex h-full flex-col justify-center space-y-2 p-4" onClick={() => toggleOpen()}>
        <div className="bg-neutral-black h-0.5 w-8" />
        <div className="bg-neutral-black h-0.5 w-8" />
        <div className="bg-neutral-black h-0.5 w-8" />
      </button>
      <div
        className={clsxm(
          "absolute top-20 right-0 z-20 flex h-screen max-h-[calc(100vh-80px)] w-64 origin-top-right flex-col items-start gap-5 overflow-y-auto bg-white/80 p-3 pt-5 shadow-lg backdrop-blur-lg transition-all duration-300 ease-in-out",
          isOpen ? "translate-x-0 scale-x-100" : "translate-x-full scale-x-0",
        )}>
        {children}
      </div>
    </div>
  );
};

export default memo(SideDrawer);
